import gql from 'graphql-tag';

import { DEAL_ACTIVITY_FRAGMENT } from './fragments/dealEventActivity.fragment';

export const MOVE_TO_TOMORROW_DATE_EVENT_ACTIVITIES = gql`
  mutation moveToTomorrowDateEventActivities($input: MoveToTomorrowEventActivitiesInput!) {
    dealActivity {
      result: moveToTomorrowEventActivities(input: $input) {
        error
        success
        list {
          __typename
          ...DealEventActivityFields
        }
      }
    }
  }
  ${DEAL_ACTIVITY_FRAGMENT}
`;
